import type { Currency } from '@weft/types';
import { formatNumber } from '@weft/utils';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import React from 'react';

type LightInvoiceProductItemProps = {
  name?: string;
  price: number
  units: number;
  currency: Currency;
};

export const LightInvoiceProductItem: React.FC<LightInvoiceProductItemProps> = ({ name, price, units, currency }) => {
  const currencySymbol = getCurrencySymbol(currency);

  return (
    <div
      className="text-placeholder flex w-full flex-wrap justify-between text-base font-normal"
    >
      <div>{name}</div>
      <div>{`${formatNumber(units)} X ${currencySymbol}${formatNumber(price)}`}</div>
    </div>
  );
};